export default __webpack_public_path__ + "static/media/icn-megaphone-plus-active.3e1810cd.svg";